import styled from 'styled-components';
import { gridSize } from '../Calendar';
export const StyledContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${gridSize * 7}px;
`;
export const StyledHeaderContainer = styled.div `
  width: ${gridSize * 7}px;
`;
export const StyledBodyContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: ${gridSize * 7}px;
  min-height: ${gridSize * 6}px;
`;
//# sourceMappingURL=SingleCalendar.styles.js.map